import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioInserirComponent } from './usuario-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: UsuarioInserirComponent }
    ])],
    exports: [RouterModule]
})
export class UsuarioInserirRoutingModule { }
